'use strict';

var $ = require('jquery'),
    extend = require('../object/extend');

/**
 * Cached script. override caching script default by getScript jquery
 * @param url
 * @param options
 * @returns {Deferred}
 */
module.exports = function cachedScript(url, options) {
    // Allow user to set any option except for dataType, cache, and url
    options = extend(options || {}, {
        dataType: 'script',
        cache: true,
        url: url
    });

    // Use $.ajax() since it is more flexible than $.getScript
    // Return the jqXHR object so we can chain callbacks
    return $.ajax(options);
};
